const exactMath = require('exact-math');
type NumType = number | string;

export default class Calc {
	static add = (a: NumType, b: NumType) => exactMath.add(+a || 0, +b || 0) as number;
	static sub = (a: NumType, b: NumType) => exactMath.sub(+a || 0, +b || 0) as number;
	static mul = (a: NumType, b: NumType) => exactMath.mul(+a || 0, +b || 0) as number;
	static div = (a: NumType, b: NumType) => exactMath.div(+a || 0, +b || 0) as number;
	static ceil = (a: NumType) => exactMath.ceil(+a || 0) as number;
	static round = (a: NumType) => exactMath.round(+a || 0) as number;
	static floor = (a: NumType) => exactMath.floor(+a || 0) as number;
	static pow = (a: NumType, b: NumType) => exactMath.pow(+a || 0, +b || 0) as number;
	static formula = (str: string) => exactMath.formula(str) as number;
	static trim = (a: NumType, precision: NumType = 2) =>
		this.div(this.floor(this.mul(+a || 0, this.pow(10, +precision))), this.pow(10, +precision));
}
